import React from "react";
import FormativeAssessment from "./FormativeAssessment";
import { useLaunchParams } from "./shared/useLaunchParams";
import MissingChapter from "./shared/MissingChapter";

/** LTI route wrapper for the summative Chapter Quiz flow. Reuses the formative
 *  item runner with source="quiz" (data from /pe/quiz, no practice gate). */
const QuizAssessmentPage: React.FC = () => {
  const { chapterId, tier, lang, role, studentAssignmentId } = useLaunchParams();
  if (!chapterId) return <MissingChapter screen="quiz" lang={lang} />;
  return (
    <FormativeAssessment
      source="quiz"
      chapterId={chapterId}
      tier={tier}
      lang={lang}
      role={role}
      studentAssignmentId={studentAssignmentId}
    />
  );
};

export default QuizAssessmentPage;
